import { SVGProps } from 'react';

const SvgLongArrowRight = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" {...props}>
        <path d="M8.08 0v3.2H.944L.92 4.808h7.16V8l4-4-4-4Z" />
    </svg>
);
export default SvgLongArrowRight;
